import { call, put } from 'redux-saga/effects';
import { Saga } from 'custom-types/saga';

import { addNegativeToast, errorIdentifier } from 'modules/toastContainer';
import {
  analyticsPerformanceDataError,
  analyticsPerformanceTabData,
} from 'modules/experiments/ducks/actions';
import {
  ExperimentsAction,
  PerformanceTabExperimentData,
  PerformanceTabQuery,
} from 'modules/experiments/types';
import { getExperimentsTranslations } from 'modules/experiments/utils';
import { fetchExperimentAnalyticsPerformanceTab } from 'api/ExperimentsAPI';

type ExperimentAnalyticsSaga = Saga<
  ExperimentsAction<Record<string, unknown>, PerformanceTabExperimentData>
>;

type FetchPerformanceTabExperimentData = {
  data: {
    experiment: PerformanceTabExperimentData;
  };
};

export function* setPerformanceTabDataSaga({
  queryData,
}: ExperimentsAction<{ queryData: PerformanceTabQuery }>): ExperimentAnalyticsSaga {
  try {
    const {
      data: { experiment },
    }: FetchPerformanceTabExperimentData = yield call(
      fetchExperimentAnalyticsPerformanceTab,
      queryData,
    );

    yield put(analyticsPerformanceTabData(experiment));
  } catch (error) {
    yield put(analyticsPerformanceDataError());

    const errorMessage = yield call(
      getExperimentsTranslations,
      'errorMessage.analyticsPerformanceTab',
    );

    yield put(
      addNegativeToast(
        errorMessage,
        errorIdentifier({
          errorMessage,
          source: 'setPerformanceTabDataSaga',
          error,
          additional: queryData,
        }),
      ) as any,
    );
  }
}
